var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M23,1H1A1,1,0,0,0,0,2v8a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V2A1,1,0,0,0,23,1ZM10,7H4V5h6Zm9,0a1,1,0,1,1,1-1A1,1,0,0,1,19,7Z"}}),_c('path',{attrs:{"d":"M23,13H1a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V14A1,1,0,0,0,23,13ZM10,19H4V17h6Zm9,0a1,1,0,1,1,1-1A1,1,0,0,1,19,19Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }